module.exports = __webpack_public_path__ + "img/galeria-forrageiras-3.821d1914.jpg";